/**
 * Use to match KeyboardEvent.key
 * @source https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
 * @see KeyboardCode
 */
export enum KeyboardKey {
    Enter = 'Enter', // includes Numpad Enter
    Escape = 'Escape',
    ArrowUp = 'ArrowUp',
    ArrowDown = 'ArrowDown',
    ArrowLeft = 'ArrowLeft',
    ArrowRight = 'ArrowRight',
    Backspace = 'Backspace',
    Space = ' ',
    Delete = 'Delete',
    Tab = 'Tab',
    Shift = 'Shift',
    Control = 'Control',
    Alt = 'Alt',
    Pause = 'Pause',
    CapsLock = 'CapsLock',
    PageUp = 'PageUp',
    PageDown = 'PageDown',
    End = 'End',
    Home = 'Home',
    Insert = 'Insert',
    Meta = 'Meta', // windows key, ⌘,
    ContextMenu = 'ContextMenu', // windows/os on right
    F1 = 'F1',
    F2 = 'F2',
    F3 = 'F3',
    F4 = 'F4',
    F5 = 'F5',
    F6 = 'F6',
    F7 = 'F7',
    F8 = 'F8',
    F9 = 'F9',
    F10 = 'F10',
    F11 = 'F11',
    F12 = 'F12',
    NumLock = 'NumLock',
    ScrollLock = 'ScrollLock',
    OpenParentheses = '(',
    CloseParentheses = ')',
    AltGraph = 'AltGraph',
}
